import React from 'react';
import { Grid, Col, Button } from 'react-bootstrap';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Cookies from 'js-cookie';

import styles from './CookieAgreement.module.scss';

const cookieKey = 'cookiesAgreement';

class CookieAgreement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      agreed: (Cookies.get(cookieKey) || false)
    };
    this.agree = this.agree.bind(this);
  }

  agree() {
    Cookies.set(cookieKey, true);
    this.setState({ agreed: true });
  }

  popup() {
    if (this.state.agreed) {
      return null;
    }
    return (
      <div className={styles.popup}>
        <Grid>
          <Col xs={8} md={10} className={styles.agreement}>
            We use cookies to ensure that we give you the best experience
            on our website. By continuing to use https://www.airmates.eu
            you will be agreeing to the website&nbsp;
            <a
              href="http://www.time-matters.com/data-protection-notice"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy and the use Of Cookies
            </a>
      &nbsp;while using the website.
          </Col>
          <Col xs={4} md={2}>
            <Button className={styles.button} onClick={this.agree}>Got it!</Button>
          </Col>
        </Grid>
      </div>
    );
  }

  render() {
    return (
      <div className={styles.popupContainer}>
        <ReactCSSTransitionGroup
          transitionName="popup"
          transitionAppear
          transitionLeave
          transitionAppearTimeout={800}
          transitionEnter={false}
          transitionLeaveTimeout={800}
        >
          {this.popup()}
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

export default CookieAgreement;
